import { Icon, Shadow, Text, HStack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';
import { Pressable } from 'react-native';

import { CardListItemProps } from '../..';
import { LateralBar } from '../../../LateralBar';

export const CardProductItemMobile: React.FC<CardListItemProps> = ({
  label,
  renderFields,
  hasButtonDetails,
  onPressDetails,
  color,
}) => {
  return (
    <Shadow level={1} borderRadius="sm" p="20px">
      <LateralBar backgroundColor={color} borderTopLeftRadius="sm" borderBottomLeftRadius="sm" />
      <HStack alignItems="center">
        <VStack space={Spacing['inline.quarck']} alignItems="flex-start" flex={1}>
          <Text fontSize={Typography['fontsize.md']} variant="semibold">
            {label.toUpperCase()}
          </Text>
          {renderFields.map((field, index) => (
            <HStack
              key={index}
              space={Spacing['inline.quarck']}
              alignItems="flex-start"
              minW="130px">
              <Text fontSize={Typography['fontsize.xs']} color="neutral.medium">
                {field.label}
              </Text>
              <Text
                fontSize={Typography['fontsize.md']}
                color={field.value >= 0 ? 'neutral.darkest' : 'feedback.error.default'}
                variant="semibold">
                {Utils.Mask.Money(field.value)}
              </Text>
            </HStack>
          ))}
        </VStack>

        {hasButtonDetails && (
          <Pressable onPress={onPressDetails}>
            <Icon testId="testID" name="ChevronRight" color={Color['neutral.dark']} size="xs" />
          </Pressable>
        )}
      </HStack>
    </Shadow>
  );
};
